import { Tag as ATag, TagProps as ATagProps } from "antd";
import { CheckableTagProps as ACheckableTagProps } from "antd/es/tag";
import styled from "styled-components";
export type TagProps = ATagProps;
export type CheckableTagProps = ACheckableTagProps;

export const Tag = styled(ATag)`
    display: inline-flex;
    gap: var(--ant-margin-xxs);
    align-items: center;

    font-size: var(--ant-font-size);
    line-height: var(--ant-line-height-sm);
    padding-inline: calc(var(--ant-padding-sm) - var(--ant-line-width));

    &:has(.sol-antd-icon:first-child:last-child) {
        padding-inline: 0;
        aspect-ratio: 1;
        height: 1lh;
        justify-content: center;
    }
`;
